<script setup>
import {computed} from 'vue';
import {settingsBreadcrumbsForKey} from './breadcrumbs';

const breadcrumbs = computed(() => settingsBreadcrumbsForKey('navigation:backOffice.sidebar.myCompany.settings.frontpageAndFooter'));
</script>

<template>
    <div>
        <frosted-bar :breadcrumbs="breadcrumbs">
            <div class="flex items-center justify-between space-x-4">
                <h1>{{ _mft('navigation:backOffice.sidebar.myCompany.settings.frontpageAndFooter') }}</h1>
            </div>
        </frosted-bar>

        <card-tabbed class="mt-8">
        <card-tabbed-tab
            value="frontpages"
            :title="_mft('setting:footer.frontPages.label')"
            :active="true"
        >
            <settings-front-page
                :label="_mft('setting:footer.frontPage.loggedOut.label')"
                front-page-type="website"
            />

            <hr class="my-4">

            <settings-front-page
                :label="_mft('setting:footer.frontPage.loggedIn.label')"
                front-page-type="customerarea"
            />
        </card-tabbed-tab>

        <card-tabbed-tab
            value="footer"
            :title="_mft('setting:footer.label')"
        >
            <settings-footer />
        </card-tabbed-tab>
        </card-tabbed>
    </div>
</template>

<style scoped>

</style>
